import script from "./ConsoleAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleAnalytics.vue?vue&type=style&index=0&id=42ac2980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ac2980"]])

export default __exports__